import { render, staticRenderFns } from "./TelefoneSignatario.vue?vue&type=template&id=066be642"
import script from "./TelefoneSignatario.vue?vue&type=script&lang=js"
export * from "./TelefoneSignatario.vue?vue&type=script&lang=js"
import style0 from "./TelefoneSignatario.vue?vue&type=style&index=0&id=066be642&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports